/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagHu: {
  name: 'flag_hu';
  data: string;
} = {
  name: 'flag_hu',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#D43516" d="M0 0h32v8H0V0Z"/><path fill="#fff" d="M0 8h32v8H0V8Z"/><path fill="#388D00" d="M0 16h32v8H0v-8Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
